import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme, media } from '../theme';
import ibisLogo from '../assets/graphics/ibisingold.png';
import firegoldLogo from '../assets/graphics/firegold.png';

// Styled components
const HeaderContainer = styled.header`
  display: flex;
  align-items: start;
  flex-direction: column;
  padding: 0 ${theme.spacing.xl};
  color: ${theme.colors.gold};
  font-size: ${theme.fontSizes.giant};

  ${media.desktopMd} {
    padding: 0;
  }
`;

const LogoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: ${theme.spacing.xl};
`;

const Logo = styled.img`
  height: ${theme.sizes.logoHeight};
  width: auto;

  ${media.mobileLg} {
    height: ${theme.sizes.logoHeightMobile};
  }
`;

/**
 * Props pro Header komponentu
 */
interface HeaderProps {
  /** Volitelný obsah (např. title) */
  children?: ReactNode;
}

/**
 * Header komponenta s logy IBIS InGold a FireGOLD
 */
export default function Header({ children }: HeaderProps): React.ReactElement {
  return (
    <HeaderContainer>
      <LogoGroup>
        <Logo src={ibisLogo} alt="IBISINGOLD" />
        <Logo src={firegoldLogo} alt="FireGOLD" />
      </LogoGroup>
      {children}
    </HeaderContainer>
  );
}
